import { getFrontendEnvData } from '@prishapolicy/shared/auth-client';
import { Button } from '@prishapolicy/shared/ui';
import { useArticleContext } from '@prishapolicy/w3/ui';
import { twMerge } from 'tailwind-merge';

export const ImageOverlayCard = (props: {
  heading: string;
  insuranceType: string;
  backgroundImage: string;
  overlayColor?: string;
  primaryLink:string;
  secondaryLink?:string;
}) => {

  const urls = getFrontendEnvData().urls;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const frontMatter = useArticleContext()!;

  return (
    <div
      className="relative my-10 rounded-lg py-10  px-12"
      style={{
        ...(props.backgroundImage && {
          backgroundImage: `url(${
            props.backgroundImage.startsWith('http')
              ? props.backgroundImage
              : `/blog-assets/${frontMatter?.slug}/${props.backgroundImage}`
          })`,
          backgroundSize: 'cover',
        }),
      }}
    >
      <div className={twMerge(`absolute inset-0 z-0 opacity-[0.7] bg-${props.overlayColor} rounded-lg`)}></div>
      <div className="relative z-10">
        <h6 className="text-title-6 font-bold text-black">{`Get the best ${props.insuranceType} quote`}</h6>
        <h1 className="text-[48px] font-bold text-black">{props.heading}</h1>
        <div className="flex flex-col gap-4 xl:flex-row xl:items-center">
          <Button
            text={`Get ${props.insuranceType} Insurance`}
            onClick={() => {
              window.location.href = urls.w3 + props.primaryLink;
            }}
            className="capitalize"
          />
          <Button
            text={`Schedule Call`}
            onClick={() => {
              window.open('https://calendly.com/prishapolicy/callwithexpert', '_blank', 'noopener,noreferrer');
            }}
            theme="outlined"
          />
        </div>
      </div>
    </div>
  );
};
